/**
 * @file CompetitionService — component-facing access to a single competition.
 *
 * "Current" is not special: it is simply the manifest at CURRENT_MANIFEST_URL.
 * Everything (current and archived) goes through the same cached getManifest
 * pipeline and the same normalizer, so there is no duplicated loading logic.
 */

import { CURRENT_MANIFEST_URL } from '../config/scrWeeklyConfig';
import { getManifest } from './manifestCache';

/**
 * @typedef {import('../models/manifest').Competition} Competition
 */

export const CompetitionService = {
  /**
   * The current week's competition (manifest = current.json).
   * @returns {Promise<Competition>}
   */
  getCurrentCompetition() {
    return getManifest(CURRENT_MANIFEST_URL);
  },

  /**
   * Any competition by its manifest URL — current or archived, same path.
   * @param {string} manifestUrl
   * @returns {Promise<Competition>}
   */
  getCompetitionByManifestUrl(manifestUrl) {
    return getManifest(manifestUrl);
  },

  /** URL of the current manifest (e.g. for a download button). */
  getManifestUrl() {
    return CURRENT_MANIFEST_URL;
  },
};
